import React, { useState } from "react";
import { View } from "react-native";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import { TextLink } from "./TextLink";
import Text from "./AppText";
import tw from "twrnc";
import { Dropdown } from "react-native-element-dropdown";
import HelpTip from "@/components/settings/HelpTip";
import { text as settingsText } from "@/components/settings/theme";
import { t } from "@/localization";

// align "left" + helpTopic: the event settings look (left-aligned hint line with
// a help tip). Default: right-aligned, as on the create-event forms.
const TimezonePicker = ({
  value,
  onChange,
  style,
  align = "right",
  helpTopic,
}) => {
  const [customizeTZ, setCustomizeTZ] = useState(false);

  const timezones = moment.tz
    .names()
    .sort((a, b) => {
      const aIsUS = a.startsWith("US/");
      const bIsUS = b.startsWith("US/");
      if (aIsUS && !bIsUS) return -1;
      if (!aIsUS && bIsUS) return 1;
      return a.localeCompare(b);
    })
    .map((tz) => ({
      name: tz,
      value: tz,
    }));

  return (
    <View style={style}>
      {!customizeTZ ? (
        <View
          style={tw`flex-row items-center ${
            align === "left" ? "justify-start mt-1 mb-2" : "justify-end my-2.5"
          }`}
        >
          <Text style={align === "left" ? settingsText.hint : undefined}>
            {t("Timezone: {timezone}", { timezone: value ?? "" })}{" "}
          </Text>
          <TextLink
            text={t("Change")}
            onPress={() => {
              setCustomizeTZ(true);
            }}
            textStyle={align === "left" ? settingsText.link : {}}
          />
          {!!helpTopic && <HelpTip topic={helpTopic} />}
        </View>
      ) : (
        <Dropdown
          data={timezones}
          labelField="name"
          valueField="value"
          value={value}
          onChange={(item) => onChange(item.value)}
          search
          searchPlaceholder={t("Search timezone...")}
          style={tw`bg-white mt-2 mb-4 p-2.5 px-4 border border-gray-300 rounded-lg h-[50px]`}
          containerStyle={tw`mb-4 p-2.5 border border-gray-300 rounded-lg`}
          selectedTextStyle={tw`text-black text-sm`}
          itemTextStyle={tw`text-black text-sm`}
          placeholder={t("Select timezone")}
        />
      )}
    </View>
  );
};

export default TimezonePicker;
